import React, { useState, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  labelText: {
    position: 'absolute !important',
    color: theme.palette.text.secondary,
  },
  root: {
    minHeight: 70,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflow: 'hidden',
    border: '1px solid',
    color: 'rgba(0, 0, 0, 0.87)',
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.0)',
    borderColor: theme.palette.grey[400],
    padding: '30px 0',
    transition: 'box-shadow 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,  border-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, border-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    '&:hover': {
      borderColor: theme.palette.grey[200],
    },
    '&:focus-within': {
      borderColor: '#198BFF',
      boxShadow: 'inset 0 0 0 1px #198BFF',
      border: '1px solid',
    },
    '& > input': {
      zIndex: 2,
      width: '100%',
      height: '100%',
      opacity: 0,
      position: 'absolute',
      padding: 5,
      left: 0,
      top: 0,
    },
    '& > button': {
      zIndex: 3,
      position: 'absolute',
      padding: 4,
      left: 2,
      top: 2,
    },
    '& > label': {
      zIndex: 1,
      position: 'absolute',
    },
    '& > img': {
      zIndex: 0,
      maxWidth: '100%',
      maxHeight: '300px',
    },
  },
}))

export default function FileInput({
  classes = {},
  label = 'Choose File',
  required = false,
  defaultImage = '',
  showDefaultImage = false,
  onChange = () => console.error('Please Add change handler'),
}) {
  const classNames = useStyles()
  const [data, setData] = useState('')
  const [rawData, setRawData] = useState('')
  const [showDefault, setShowDefault] = useState(showDefaultImage)
  const [selectedFile, setSelectedFile] = useState()
  const regex = /(image)[/][A-Za-z]*/g

  const handleChange = (event) => {
    if (!event.target.files[0]) return

    const file = event.target.files[0]
    setSelectedFile(file)
    const oFReader = new FileReader()
    const { value } = event.target

    setData(event.target.value)
    setShowDefault(false)
    oFReader.readAsDataURL(event.target.files[0])

    oFReader.onload = (oFREvent) => {
      setRawData(oFREvent.target.result)
      if (onChange) onChange([file, oFREvent.target.result, value])
    }
  }

  const cleanData = () => {
    setData('')
    setRawData('')
    setShowDefault(false)
    setSelectedFile(null)
    if (onChange) onChange('')
  }
  const isIamge = useMemo(() => {
    return regex.test(selectedFile?.type)
  }, [selectedFile])

  return (
    <div className={`${classNames.root} ${classes.root}`}>

      <input
        value={data}
        required={required}
        className={classes.input}
        type="file"
        onChange={handleChange}
      />

      <IconButton onClick={cleanData} className={classes.icon}>
        <CloseIcon />
      </IconButton>

      {(selectedFile && isIamge) && <img src={showDefault ? rawData || defaultImage : rawData} alt="" />}
      {(selectedFile && !isIamge) && <Typography className={classNames.labelText} variant="caption" color="inherit">{selectedFile.name}</Typography> }

      {!data && <Typography className={classNames.labelText} variant="caption" color="inherit">{label}</Typography>}

    </div>
  )
}

FileInput.prototype = {
  label: PropTypes.string,
  required: PropTypes.bool,
  showDefaultImage: PropTypes.boo,
  classes: PropTypes.array,
  defaultImage: PropTypes.string,
  onChage: PropTypes.func,
}
